<div class="shareContainer">

  <div class="shareModalBox">
    <div class="backArrowSection">
      <ion-icon (click)="dismiss()" name="close-outline"></ion-icon>
    </div>
    <div class="imgDiv">
      <img class="vegboost-logo" [src]="srcIconBoost" alt="VegBoost">
    </div>
    <span class="title-share">{{'vegBoost' | translate}}</span>
    <div class="txt-question">
      {{'activeVegboost' | translate}}
    </div>
    <div class="txt-description">
      {{'highlitedFor' | translate }} {{ countdown }} {{'highlight' | translate}}
    </div>
  </div>

</div>